import Box from '@component/Box';
import Icon from '@component/icon/Icon';
import React from 'react';

const IconStyle = {
  position: 'absolute',
  top: '1px',
  right: '1px',
};

const ImagePreview: React.FC<{
  src: string;
  deleteImage: () => void;
  height: string;
  width: string;
}> = ({ src, deleteImage, height, width }) => {
  return (
    <Box position="relative">
      <div
        style={{
          backgroundColor: 'red',
          position: 'absolute',
          top: 0,
          right: 0,
          width: '20px',
          display: 'flex',
          borderRadius: '50%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Icon
          defaultcolor="white"
          style={{ paddingTop: '1px', paddingBottom: '1px' }}
          onClick={deleteImage}
          variant="small"
        >
          close
        </Icon>
      </div>
      <img
        style={{
          objectFit: 'cover',
          border: '1px solid #339059',
          margin: '5px',
          borderRadius: '5px',
        }}
        height={height}
        width={width}
        src={src}
      />
    </Box>
  );
};

export default ImagePreview;
